













import Vue from 'vue';
import {Component, Model} from 'vue-property-decorator';
import Parts from "@/components/Money/Parts.vue";
@Component({
  components: {Parts}
})
export default class CategoryInfo extends Vue {
@Model('change',{required:true,type:String}) readonly name!:string
}
